/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all configuration parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerFindAllConfiguration: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/setting/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all feature parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerFindAllFeatures: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/setting/feature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create or update a configuration parameter.
         * @param {ConfigurationParameterDto} configurationParameterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerUpdateConfiguration: (configurationParameterDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationParameterDto' is not null or undefined
            assertParamExists('settingControllerUpdateConfiguration', 'configurationParameterDto', configurationParameterDto);
            const localVarPath = `/setting/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(configurationParameterDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create or update a feature parameter.
         * @param {FeatureParameterDto} featureParameterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerUpdateFeature: (featureParameterDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'featureParameterDto' is not null or undefined
            assertParamExists('settingControllerUpdateFeature', 'featureParameterDto', featureParameterDto);
            const localVarPath = `/setting/feature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(featureParameterDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all configuration parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerFindAllConfiguration(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.settingControllerFindAllConfiguration(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all feature parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerFindAllFeatures(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.settingControllerFindAllFeatures(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create or update a configuration parameter.
         * @param {ConfigurationParameterDto} configurationParameterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerUpdateConfiguration(configurationParameterDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.settingControllerUpdateConfiguration(configurationParameterDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create or update a feature parameter.
         * @param {FeatureParameterDto} featureParameterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerUpdateFeature(featureParameterDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.settingControllerUpdateFeature(featureParameterDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SettingsApiFp(configuration);
    return {
        /**
         *
         * @summary Get all configuration parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerFindAllConfiguration(options) {
            return localVarFp
                .settingControllerFindAllConfiguration(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all feature parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerFindAllFeatures(options) {
            return localVarFp
                .settingControllerFindAllFeatures(options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create or update a configuration parameter.
         * @param {ConfigurationParameterDto} configurationParameterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerUpdateConfiguration(configurationParameterDto, options) {
            return localVarFp
                .settingControllerUpdateConfiguration(configurationParameterDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create or update a feature parameter.
         * @param {FeatureParameterDto} featureParameterDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerUpdateFeature(featureParameterDto, options) {
            return localVarFp
                .settingControllerUpdateFeature(featureParameterDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     *
     * @summary Get all configuration parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingControllerFindAllConfiguration(options) {
        return SettingsApiFp(this.configuration)
            .settingControllerFindAllConfiguration(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all feature parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingControllerFindAllFeatures(options) {
        return SettingsApiFp(this.configuration)
            .settingControllerFindAllFeatures(options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create or update a configuration parameter.
     * @param {ConfigurationParameterDto} configurationParameterDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingControllerUpdateConfiguration(configurationParameterDto, options) {
        return SettingsApiFp(this.configuration)
            .settingControllerUpdateConfiguration(configurationParameterDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create or update a feature parameter.
     * @param {FeatureParameterDto} featureParameterDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    settingControllerUpdateFeature(featureParameterDto, options) {
        return SettingsApiFp(this.configuration)
            .settingControllerUpdateFeature(featureParameterDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
